// extracted by mini-css-extract-plugin
export default {"boton":"btn_boton__TIG3g","sdsd":"btn_sdsd__Vo5FS"};